import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const SuccessPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const creds = location.state?.creds;

    if(!creds) return <div>Invalid Access</div>;

    return (
        <div className="container contentmid">
            <div className="alert alert-success text-center">
                <h3>Registration Successful!</h3>
                <p>Please note down your Application Number.</p>
            </div>
            <div className="panel panel-info">
                <div className="panel-heading">Your Login Credentials</div>
                <div className="panel-body text-center">
                    <h2>Application No: <span style={{color:'red'}}>{creds.applicationNo}</span></h2>
                    <h4>Password: {creds.password}</h4>
                    <p className="text-muted">(Save this for future logins)</p>
                    <br/>
                    <button className="btn btn-primary" onClick={() => navigate('/services/counselling/login')}>
                        Proceed to Login
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SuccessPage;